module.exports = __webpack_public_path__ + "static/media/ken_wheeler.cdcc7ff4.jpg";